export default __webpack_public_path__ + "static/media/str1.654b7458.svg";